import script from "./ColorCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./ColorCard.vue?vue&type=script&setup=true&lang=ts"

import "./ColorCard.vue?vue&type=style&index=0&id=34dabe40&lang=css"

const __exports__ = script;

export default __exports__